'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = require('./remote/auth');

var Auth = {
    postAddCreditCard: _auth.AuthRemote.postAddCreditCard,
    postConfirmPassword: _auth.AuthRemote.postConfirmPassword,
    postForgotPassword: _auth.AuthRemote.postForgotPassword,
    postPayment: _auth.AuthRemote.postPayment,
    postResetPassword: _auth.AuthRemote.postResetPassword,
    postUpdatePassword: _auth.AuthRemote.postUpdatePassword,
    putAddCreditCard: _auth.AuthRemote.putAddCreditCard
};

exports.default = Auth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/auth.js
// module id = AGZl
// module chunks = 60